import React from 'react';
import { BaseButton, useT } from '@repo/common';

function EmploymentTypeList({ onSelect }) {
  const t = useT();
  const options = [
    'Full-time',
    'Part-time',
    'Internship',
    'Contract worker',
    'Temporary worker',
    'Freelancer',
  ];

  return (
    <div
      className='w-full min-w-[334px] bg-grayscale-gray00 border border-grayscale-gray02 
                rounded-[15px] p-2 shadow-popup-02'
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <ul role='menu' className='list-none p-0 m-0'>
        {options.map((option) => (
          <li
            key={option}
            className='flex items-center rounded-lg transition-colors duration-150'
          >
            <BaseButton
              type='text'
              size='m'
              hideIcon
              bgclass='bg-grayscale-gray00'
              borderclass='border-none'
              textclass='justify-start'
              hoverclass='hover:bg-grayscale-gray01 hover:text-text-primary'
              activeclass='active:bg-grayscale-gray02 active:text-text-primary'
              width='100%'
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onSelect(option);
              }}
              leftalign='true'
            >
              {t(
                option,
                {
                  'Full-time': '정규직',
                  'Part-time': '파트타임',
                  Internship: '인턴십',
                  'Contract worker': '계약직',
                  'Temporary worker': '임시직',
                  Freelancer: '프리랜서',
                }[option],
              )}
            </BaseButton>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default EmploymentTypeList;
